import { Controller } from "@hotwired/stimulus";

/**
 * data-controller="checkbox-all"
 *
 * item すべてが選択されていたら all チェックボックスも選択状態に、
 * 1 つでも選択されていなかったら all チェックボックスは非選択状態にする。
 * 逆に、 all チェックボックスのチェックを外したら item すべてのチェックを外す。
 * 連動して変わったチェックボックスの click や change イベントは飛ばないので注意。
 *
 * all チェックボックスに `data-checkbox-all-target="all"`
 * 他のチェックボックスに `data-checkbox-all-target="item"`
 *
 * disabled な item は全選択・全解除の対象外とする。
 * all チェックボックスの状態も disabled item を除いた enabled item のみで判定する。
 */
export default class extends Controller {
  static targets = ["all", "item"];

  connect() {
    /** @type HTMLInputElement */
    const allTarget = this.allTarget;
    /** @type [HTMLInputElement] */
    const itemTargets = this.itemTargets;

    // disabled item を除いた enabled item がすべて選択済みなら all をチェック
    const enabledItems = itemTargets.filter((item) => !item.disabled);
    allTarget.disabled = enabledItems.length === 0;
    allTarget.checked =
      !allTarget.disabled && enabledItems.every((item) => item.checked);
    allTarget.addEventListener("click", this.#clickAll);
    itemTargets.forEach((item) =>
      item.addEventListener("click", this.#clickItem),
    );
  }

  disconnect() {
    /** @type HTMLInputElement */
    const allTarget = this.allTarget;
    /** @type [HTMLInputElement] */
    const itemTargets = this.itemTargets;

    allTarget.removeEventListener("click", this.#clickAll);
    itemTargets.forEach((item) =>
      item.removeEventListener("click", this.#clickItem),
    );
  }

  #clickAll = () => {
    /** @type HTMLInputElement */
    const allTarget = this.allTarget;
    /** @type [HTMLInputElement] */
    const itemTargets = this.itemTargets;

    itemTargets.forEach((item) => {
      if (!item.disabled) item.checked = allTarget.checked;
    });
  };

  #clickItem = () => {
    /** @type HTMLInputElement */
    const allTarget = this.allTarget;
    /** @type [HTMLInputElement] */
    const itemTargets = this.itemTargets;

    // disabled item を除いた enabled item がすべて選択済みなら all をチェック
    const enabledItems = itemTargets.filter((item) => !item.disabled);
    allTarget.disabled = enabledItems.length === 0;
    allTarget.checked =
      !allTarget.disabled && enabledItems.every((item) => item.checked);
  };
}
